import {ComponentFactoryResolver, ComponentRef, Directive, Input, OnChanges, OnInit, SimpleChanges, ViewContainerRef} from '@angular/core';
import {TooltipComponent} from '@ui/components/tooltip/tooltip.component';
import {DxTextBoxComponent} from 'devextreme-angular';

export class M4UConfigTooltipDirectiveBase implements OnInit, OnChanges {

    @Input() Label: string;
    @Input() Visible = true;
    private _viewContainerRef: ViewContainerRef;
    private _componentFactoryResolver: ComponentFactoryResolver
    private _tooltipComponent: ComponentRef<TooltipComponent>;

    constructor(viewContainerRef: ViewContainerRef, componentFactoryResolver: ComponentFactoryResolver) {
        this._viewContainerRef = viewContainerRef;
        this._componentFactoryResolver = componentFactoryResolver;
    }

    ngOnInit() {
        this.SetVisible();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.Visible && changes.Visible.currentValue !== changes.Visible.previousValue) {
            this.SetVisible();
        }
        if (changes.Label && changes.Label.currentValue !== changes.Label.previousValue) {
            if (this._tooltipComponent) {this._tooltipComponent.instance.Label = this.Label; }
        }
    }

    SetVisible() {
        if (this.Visible) {
            if (!this._viewContainerRef.element.nativeElement.classList.contains('with-tooltip')) {
                this._viewContainerRef.element.nativeElement.classList.add('with-tooltip');
            }
            if (!this._tooltipComponent) {
                const componentFactory = this._componentFactoryResolver.resolveComponentFactory(TooltipComponent);
                this._tooltipComponent = this._viewContainerRef.createComponent(componentFactory);
            }
            else {
                this._viewContainerRef.insert(this._tooltipComponent.hostView);
            }
            this._tooltipComponent.instance.Label = this.Label;
        }
        else {
            if (this._viewContainerRef.element.nativeElement.classList.contains('with-tooltip')) {
                this._viewContainerRef.element.nativeElement.classList.remove('with-tooltip');
            }
            if (this._tooltipComponent) {
                this._viewContainerRef.detach(this._viewContainerRef.indexOf(this._tooltipComponent.hostView));
            }
        }
    }
}

@Directive({
    selector: ':not(dx-text-box)[configTooltip]',
})
export class M4UConfigTooltipDirective extends M4UConfigTooltipDirectiveBase {
    constructor(private viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) {
        super(viewContainerRef, componentFactoryResolver);
    }
}

@Directive({
    selector: 'dx-text-box[configTooltip]',
})
export class M4UConfigTextBoxTooltipDirective extends M4UConfigTooltipDirectiveBase {

    constructor(private textBox: DxTextBoxComponent, private viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) {
        super(viewContainerRef, componentFactoryResolver);
    }

    override SetVisible() {
        super.SetVisible();
        if (this.Visible) {
            if (!this.textBox.buttons) {
                this.textBox.buttons = [];
            }

            if (this.textBox.buttons.find((b: any) => b.name === 'tooltip') === undefined) {
                this.textBox.buttons.push({
                    name: 'tooltip',
                    location: 'after',
                    options: {
                        hoverStateEnabled: false,
                        elementAttr: {class: 'tooltip-placeholder-button'}
                    }
                });
                setTimeout(() => this.textBox.instance.repaint());
            }
        }
        else {
            if (this.textBox.buttons) {
                this.textBox.buttons = this.textBox.buttons.filter((b: any) => b.name !== 'tooltip');
                setTimeout(() => this.textBox.instance.repaint());
            }
        }
    }
}
